export const ADD_SPORT_DATA = 'ADD_SPORT_DATA';
export const RESET_SPORT = 'RESET_SPORT';

export default function reducer(state = {}, action) {
  switch (action.type) {
    case ADD_SPORT_DATA:
      return {
        ...action.payload,
      };
    case RESET_SPORT:
      return {};
    default:
      return state;
  }
}
